import React from "react";
import { ThemeMenu } from "../Theme1/Theme";
import { useParams } from "react-router-dom";

const Theme1 = ({ orgInfo,orgData }) => {
  const {orgcode, page } = useParams();
return <>{orgcode && <ThemeMenu orgInfo={orgInfo} orgData={orgData}/>}</>;
};

export default Theme1;
